import {
    ColoursObj,
    Icon,
    Typography,
    getContrastYIQ,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useSignal } from '@preact/signals-react'
import { useMemo } from 'react'
import { AccordionTransition } from '../../../../../common/AccordionTransition'
import { getFileName } from '../../../../../feat/media/media.slice'
import i18n from '../../../../../i18n/i18next'
import { CacheFile, Utils } from '../../../../../utils'
import { Expand } from '../../../expand'

export const FilesRow = ({ files }: { files?: string[] }) => {
    const open = useSignal<boolean>(false)

    useMemo(() => {
        if (files?.length && files?.length > 0) {
            files.forEach(async (f) => {
                await CacheFile(f)
            })
        }
    }, [files])
    // Ensures an itinerary files are present.
    if (!files || files.length === 0) return null

    const label = i18n.t('home.additional-files')

    return (
        <Stack gap={'8px'} paddingY="8px">
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
                onClick={(event) => {
                    open.value = !open.value
                }}
            >
                <Stack direction="row" spacing="16px" overflow="hidden">
                    <Icon
                        height="24px"
                        width="24px"
                        name={'Download'}
                        iconColour={ColoursObj.core.secondary}
                    />

                    <Typography
                        id="headerLabels"
                        variant="bodyRegular"
                        color={getContrastYIQ(ColoursObj.backgrounds.secondary)}
                        textOverflow="ellipsis"
                        align="left"
                        overflow="hidden"
                        whiteSpace="nowrap"
                        style={{
                            textUnderlineOffset: '3px',
                        }}
                    >
                        {label}
                    </Typography>
                </Stack>
                <Expand
                    expanded={open.value}
                    colour={getContrastYIQ(ColoursObj.backgrounds.secondary)}
                />
            </Stack>
            <AccordionTransition open={open.value}>
                {files.map((url: string, index: number) => {
                    return (
                        <Typography
                            id={'file-' + index}
                            key={index}
                            style={{
                                height: 'fit-content',
                                background: ColoursObj.backgrounds.secondary,
                                padding: '0px 40px 8px 40px',
                                display: 'flex',
                                flexWrap: 'nowrap',
                                justifyContent: 'flex-start',
                            }}
                            onClick={() => {
                                Utils.downloadAndOpenFile(url)
                            }}
                            variant="bodyRegularUnderlined"
                            color={getContrastYIQ(
                                ColoursObj.backgrounds.secondary
                            )}
                        >
                            {getFileName(url)}
                        </Typography>
                    )
                })}
            </AccordionTransition>
        </Stack>
    )
}
